<template>
    <VueDatePicker 
        inline
        :multi-dates="true"
        :enable-time-picker="false"
        :id="`date-input-${name}`"
        :class="className"
        :readonly="isDisabled"
        :rules="rules"
        :model-type="dateFormat || 'dd-MM-yyyy'"
        :required="isRequired"
        :time-picker="false"
        :clearable="false"
        :format="convertFormatDate"
        :locale="locale"
        :cancel-text="$t('button.cancel')"
        :select-text="$t('button.select')"
        :auto-apply="true"
        :min-date="minDate"
        :max-date="maxDate"
        v-model="selectedDates"
    />
</template>

<script setup>
  import {useLocales} from "@/composables/locales";
  import VueDatePicker from '@vuepic/vue-datepicker';
  import '@vuepic/vue-datepicker/dist/main.css'
  import {ref, computed, watch} from 'vue'

  const emits = defineEmits(['handleDateClick'])

  const {locale} = useLocales()
  const props = defineProps( {
    icon: String,
    iconDir: String,
    name: String,
    id: String,
    modelValue: String,
    placeholder: String,
    label: String,
    isDisabled: Boolean,
    rules: String,
    iconText: String,
    IsInputGroup: Boolean,
    addonClass: String,
    disabled: Array,
    dateFormat: String,
    minDate: String,
    maxDate: String,
    className: String,
    selectDates: Array
  })

  const selectedDates = ref(props.selectDates ?? [])

  const convertFormatDate = computed(() => {
    const dateFormat = locale.value === 'fr' ? 'dd-MM-yyyy' : 'MM-dd-yyyy';
    return dateFormat;
  })

  watch(selectedDates, (newDates, oldDates) => {
    if (newDates.length > oldDates.length) {
      const addedDate = newDates[newDates.length - 1]
      if(addedDate) emits('handleDateClick', addedDate);
    }

    if (newDates.length < oldDates.length) {
      const removedDate = oldDates.find(
        (date) => !newDates.some((newDate) => newDate === date)
      );
      if(removedDate) emits('handleDateClick', removedDate);
    }
  });

</script>
<style scoped>
    @import "@eonasdan/tempus-dominus/dist/css/tempus-dominus.min.css";

    input.invalid {
      border: 1px solid red;
    }

    :root {
      --dp-menu-min-width: 260px;
    }
</style>
